import React from 'react';
import PreLoginSessionCheck from './PreLoginSessionCheck.js';
import ourTeams from './H-Teams';
import $ from 'jquery';
// ES6 classNameNameNameName-style
class Founders extends PreLoginSessionCheck {
	
	constructor(props) {
	  	super(props); 
	  	
	  	 this.handleMouseOver = this.handleMouseOver.bind(this);
	  	 this.handleMouseOut = this.handleMouseOut.bind(this);
	}
	
	handleMouseOver(event){
		var index = $(event.currentTarget).attr("data-index");
		$(".caption-"+index).show();
	}
	
	handleMouseOut(event){
		var index = $(event.currentTarget).attr("data-index");
		$(".caption-"+index).hide();
	}

	alttxtFn(a,b){
		return a+", "+b;
	}
	
  render() {
//console.log("ourTeams:::",ourTeams);
  	return(
		<section className="mtb product-main founder">
			<div className="container">
				<h2>Our Team</h2>
				<div className="">
					<div className="col-12 row d-flex flex-center">
						{
					 		ourTeams.map((element,index) => {			      
					        	return(			        		
					        			
					        			<a className="profile" key={index}>
						                  <figure>
						                      <div className="profile-pic" data-index={index} style={{color: "#ccc", background: 'url("../../images/teamHM/'+element.picture+'")' }} role='img' aria-label={this.alttxtFn(element.name,element.desgn)} onMouseOver={this.handleMouseOver} onMouseOut={this.handleMouseOut}></div>
						                      <figcaption className={"caption-"+index}>
						                          <h5>{element.name}</h5>
						                          <h6>{element.desgn}</h6>
						                      </figcaption>
						                  </figure>
						               </a>
					        	);			        		    
							})
				 		}
					</div>
				</div> 
			</div>
		</section>
  		);
  	}
}

export default Founders; 


// WEBPACK FOOTER //
// ./src/prelogin/src/components/OurTeam.js